import React, { Fragment, Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import LoginInvitedUser from './LoginInvitedUser';
import RegisterInvitedUser from './RegisterInvitedUser';
import Fingerprint2 from 'fingerprintjs2';
import EndpointsGetter from '../common/EndpointsGetter';
import axiosInstance from "../common/AxiosInstace";
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { Card, CardContent, Typography } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { setUserData } from '../../../store/actions/userActions';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    circularProgress: {
        'position': 'absolute', 'z-index': '1', 'margin-left': 'auto', 'margin-right': 'auto', 'top': '50%', 'left': '50%'
    },
    card: {
        width: '100%',
        maxWidth: 400,
        margin: '0 auto'
    }
});

class InvitedUsers extends Component {
    state = {
        fingerprint: '',
        email: '',
        hasAccount: false,
        isLoading: true,
        uidError: '',
        redirectUrl: ''
    }

    componentDidMount() {
        let inviteParams = this.extractUid(this.props.location.search);
        if (inviteParams.uid && inviteParams.redirectUrl) {
            axiosInstance.get(`${EndpointsGetter.getVerifyNewUserTokenEndpoint()}?uid=${inviteParams.uid}`)
                .then(response => {
                    this.getFingerprint();
                    this.setState({
                        email: response.data.emailAddress,
                        hasAccount: response.data.hasAnotherRegistration,
                        isLoading: false,
                        uid: inviteParams.uid,
                        redirectUrl: inviteParams.redirectUrl
                    })
                })
                .catch(error => {
                    this.getError(error);
                });
        } else if (!isEmpty(this.props.location.hash)) {
            let hashKey = this.props.location.hash.split('=')[0];
            if (hashKey === '#id_token' || hashKey === '#access_token') {
                this.setState({ isLoading: false });
            } else {
                this.setState({ isLoading: false, uidError: 'The provided link is incorrect or malformed.' });
            }
        } else {
            this.setState({ isLoading: false, uidError: 'The provided link is incorrect or your invitation has expired.' });
        }
    }

    getFingerprint = () => {
        if (window.requestIdleCallback) {
            requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                    let values = components.map(function (component) {
                        return component['value'];
                    });
                    this.setState({
                        fingerprint: Fingerprint2.x64hash128(values.join(''), 31)
                    });
                }.bind(this))
            }.bind(this))
        } else {
            setTimeout(function () {
                Fingerprint2.get(function (components) {
                    let values = components.map(function (component) {
                        return component['value'];
                    });
                    this.setState({
                        fingerprint: Fingerprint2.x64hash128(values.join(''), 31)
                    });
                }.bind(this))
            }.bind(this), 500)
        }
    }

    extractUid = (locationUrl) => {
        let uid = null,
            redirectUrl = null;
        let path = locationUrl.split("=");
        if (path.length === 3) {
            if (path[0] === '?uid' && path[1]) {
                uid = path[1];
                redirectUrl = path[2];
            }
        }

        return {
            uid: uid,
            redirectUrl: redirectUrl
        };
    }

    setLoginSession = async (response) => {
        let data = response.data;
        const userAccounts = await this.getUserAccounts(data.access_token);
        this.createUserSession(response.data, userAccounts.data);
    }

    getUserAccounts = async (accessToken) => {
        try {
            const response = await axiosInstance.get(EndpointsGetter.getUserAccountsEndpoint(), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken
                }
            });
            return response;

        } catch (err) {
            this.getError(err);
        }
    }

    createUserSession = ({ access_token, refresh_token, expires_in }, userAccounts) => {
        let cookieExpiry = Date.now() + 180 * 1000;
        const cookieDomain = window.location.href.includes('test') ? '.dev.test' : '.kanin.io';
        cookies.set('access_token', access_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        cookies.set('refresh_token', refresh_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        cookies.set('expires_in', expires_in, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        cookies.set('set_in', new Date().getTime(), { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
        this.redirectUserToAccount(access_token, userAccounts);
    }

    redirectUserToAccount = (accessToken, userAccounts) => {
        if (userAccounts.length === 1) {
            if (!isEmpty(this.state.redirectUrl) && this.redirectAccountBelongsToUserAccounts(this.state.redirectUrl, userAccounts)) {
                this.setAccount(userAccounts[0], accessToken);
            }
            else this.redirectToSelectAccount(accessToken, userAccounts);
        } else {
            if (!isEmpty(this.state.redirectUrl) && this.redirectAccountBelongsToUserAccounts(this.state.redirectUrl, userAccounts)) {
                let loginAccount = this.redirectAccountBelongsToUserAccounts(this.state.redirectUrl, userAccounts);
                this.setAccount(loginAccount, accessToken);

            } else this.redirectToSelectAccount(accessToken, userAccounts);
        }
    }

    redirectAccountBelongsToUserAccounts = (redirectUrl, userAccounts) => {
        return userAccounts.find((account) => account.accountUrl === redirectUrl);
    }

    redirectToSelectAccount = (accessToken, userAccounts) => {
        this.props.history.push({
            pathname: '/select-account',
            state: {
                userAccounts: userAccounts,
                accessToken: accessToken
            }
        });
    }

    setAccount = ({ id, accountUrl }, accessToken) => {
        axiosInstance.put(`${EndpointsGetter.setUserAccountEndpoint()}/${id}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                const { access_token, expires_in, refresh_token } = response.data.tokenInfo,
                    cookieExpiry = Date.now() + 120 * 1000,
                    userCookieExpiry = Date.now() + 7200 * 1000,
                    url = window.location.href,
                    cookieDomain = url.includes('test') ? '.dev.test' : '.kanin.io';

                cookies.set('access_token', access_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('refresh_token', refresh_token, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('expires_in', expires_in, { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('set_in', new Date().getTime(), { path: '/', expires: new Date(cookieExpiry), domain: cookieDomain });
                cookies.set('user', response.data.user, { path: '/', expires: new Date(userCookieExpiry), domain: cookieDomain });

                window.location.href = url.includes('test') ? `http://dev.test:3000/` : `https://${accountUrl}`;
            })
            .catch(error => {
                this.getError(error.response);
            })
    }

    getError(error) {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 404) {
            errorString = "Error 404";
        } else if (error.response.status === 400) {
            errorString = error.response.data.message;
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
        }
        this.setState({ uidError: errorString, isLoading: false });
    }

    render() {
        let { fingerprint, email, hasAccount, isLoading, uidError, uid } = this.state,
            { classes } = this.props;

        return (
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 sm:flex-col md:flex-col md:p-0")}>
                <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>
                    {
                        isLoading ? (
                            <CircularProgress className={classNames(classes.circularProgress, classes.progress)} color="secondary" />
                        ) : (
                                <div className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-72 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>
                                    <p className='kanin-title'>
                                        KANIN
                                    </p>
                                    {!isEmpty(uidError) ? (
                                        <Card className={classNames(classes.card)}>
                                            <CardContent className="flex flex-col items-center justify-center p-32">
                                                <Typography variant="title" className="card-title">{uidError}</Typography>
                                                <Link to='/login'>
                                                    Go to login page
                                                </Link>
                                            </CardContent>
                                        </Card>
                                    ) : (
                                            <Fragment>
                                                {hasAccount ?
                                                    <LoginInvitedUser fingerprint={fingerprint} email={email} setLoginSession={this.setLoginSession} /> :
                                                    <RegisterInvitedUser fingerprint={fingerprint} email={email} uid={uid} setLoginSession={this.setLoginSession} />
                                                }
                                            </Fragment>
                                        )
                                    }
                                </div>
                            )
                    }
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = {
    setUserData
};

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(InvitedUsers)));


// WEBPACK FOOTER //
// ./src/main/content/invited-users/InvitedUsers.js